import { Injectable, Inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  ErrorResponse,
  HttpErrorHandler,
  LOGIN_ROUTE,
} from '@homeleite/arch';
import { CurrentInfoService } from '@homeleite/domain';

/**
 * 401: limpa sessão/cache e manda para login.
 * Sem isso o admin fica na rota (token inválido + CurrentInfo em cache) e as listas só mostram "Falha ao buscar".
 */
@Injectable()
export class UnauthorizedHttpErrorHandler extends HttpErrorHandler {
  private readonly loginPath: string;

  constructor(
    private auth: AuthService,
    private currentInfo: CurrentInfoService,
    private router: Router,
    @Inject(LOGIN_ROUTE) @Optional() loginPath: string
  ) {
    super(10);
    this.loginPath = loginPath || '/login';
  }

  matches(error: ErrorResponse): boolean {
    return error?.isUnauthorizedError === true;
  }

  handle(_error: ErrorResponse): void {
    this.currentInfo.clear();
    this.auth.publishLogout();
    const url = this.router.url || '/';
    if (!url.startsWith(this.loginPath)) {
      this.router.navigate([this.loginPath], {
        queryParams: { src: btoa(url) },
      });
    }
  }
}
